import React, {useState} from "react";

function ComicSlideImage({index, basePath, hasBackground = false}: any) {
    const [src, setSrc] = useState(`${basePath}${index}.png`);
    const [triedFallback, setTriedFallback] = useState(false);

    const handleError = () => {
        if (!triedFallback && src.endsWith(".png")) {
            setSrc(`${basePath}${index}.webp`);
            setTriedFallback(true);
        }
    };

    return (
        <img
            src={src}
            alt={`Slide ${index}`}
            className={hasBackground ? "slide-image slide-image--withBg" : "slide-image"}
            loading="eager"
            onError={handleError}
        />
    );
}

export default ComicSlideImage;